import {
  useState, useEffect, useCallback, useRef,
} from 'react';
import client from '../apollo';

const useGraphQLQuery = ({
  query,
  variables,
  fetchPolicy = 'network-only',
  skip = false,
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // UseRef will keep value persist when components re-render
  const isMounted = useRef(true);

  const fetchData = useCallback(async() => {
    if (skip || !isMounted.current) return;
    setLoading(true);
    try {
      const result = await client.query({ query, variables, fetchPolicy });
      if (isMounted.current) {
        setData(result.data);
        setError(null);
      }
    } catch (err) {
      if (isMounted.current) {
        setError(err);
        setData(null);
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  }, [query, JSON.stringify(variables)]);

  useEffect(() => {
    isMounted.current = true;
    fetchData();

    // Clean up function, safely prevent state updates, memory leaks after the component has unmounted
    return () => {
      isMounted.current = false;
    };
  }, [fetchData]);

  return {
    data, loading, error, refetch: fetchData,
  };
};

export default useGraphQLQuery;
